// extracted by mini-css-extract-plugin
module.exports = {"text":"Content_text__EYIF8"};